<template>
  <div id="system-publish-key-relationship">
    <div class="relative ipub-p1 line-h-40 mar-b-30flex"
         style="display: flex;align-items: center;justify-content: left;">
      <a @click="changeStatus('')"
         :class="['system-publish-key-relationship--status',params.released===''?'active':'']">All</a>
      <a @click="changeStatus(true)"
         :class="['system-publish-key-relationship--status mar-l-40',params.released===true?'active':'']">Published</a>
      <a @click="changeStatus(false)"
         :class="['system-publish-key-relationship--status mar-l-40',params.released===false?'active':'']">Draft</a>
      <div class="line-h-40 ipub-p3 "
           style="margin-left:30px">

        <ipub-radio :checked="!displayPartner"
                    @change="showPartner"
                    style="display:block"
                    label="No Relationship" />
        <!-- No Sections -->
      </div>
      <div class="right-option">
        <ipub-button type="primary"
                     icon="iconAdd"
                     v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.COLLABORATION.ADD')"
                     @click="add">
          Add Partner
        </ipub-button>
      </div>
    </div>
    <div class="page-content">
      <ipub-table :columns="columns"
                  :pagination="false"
                  draggable
                  @drag="setSort"
                  :dataSource="dataSource">
        <template v-slot:img="{text}">
          <img class="ipub-table-slot-img"
               :src="`${domain}/${text}`"
               alt="">
        </template>
        <template v-slot:time="{record}">
          {{ (record.updateTime||record.createTime)?$moment(record.updateTime||record.createTime).format('HH : mm DD / MM / YYYY'): '- -' }}
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.COLLABORATION.EDIT')"
                        class="border-right">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
          <template v-if="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.COLLABORATION.PUBLISH')">
            <ipub-tooltip v-if="record.released"
                          class="border-right">
              <div slot="title">Unpublish</div>
              <ipub-icon type="iconDisable"
                         @click="able(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-else
                          class="border-right">
              <div slot="title">Publish</div>
              <ipub-icon type="iconAble"
                         @click="able(record)" />
            </ipub-tooltip>
          </template>
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.COLLABORATION.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <Add ref="key-relationship-add"
         :isVisable="isVisable"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
